<script setup>
import {computed, defineEmits, defineProps, onMounted, ref} from "vue";
import {ElMessage} from "element-plus";
import axiosApi from "@/utils/axiosApi";
import store from "@/store";
import {xm_air_login} from "@/utils/func";

const props = defineProps({
  showLogin: {
    type: Boolean,
    default: true,
  },
  mobile: {
    type: String,
    default: "",
  }
})
const emit = defineEmits(["login", "closed"])
const data = ref({
  account: "",
  password: "",
  type: "xm_air",
  login_type: "2",
  sms_text: ""
})
const loading = ref(false)
const xm_air = ref()
const number = ref(0)
let timer = null
onMounted(() => {
  if (props.mobile) {
    data.value.account = props.mobile
  }
})

const open = () => {
  if (props.mobile) {
    data.value.account = props.mobile
  }
}
const text = computed(() => {
  return number.value > 0 ? `${number.value}秒` : "获取验证码"
})
const login = () => {
  if (!/^1[2-9]\d{9}$/.test(data.value.account)) {
    return ElMessage.error("请输入正确的手机号码")
  }

  if (!data.value.sms_text || !data.value.password) {
    return ElMessage.error("请输入短信验证码")
  }
  loading.value = true
  new axiosApi({
    encode: 'site',
    method: 'user/login',
    body: data.value
  }).send(res => {
    if (res.message.code !== "000") {
      return ElMessage.error(res.message.content)
    }
    xm_air_login(res.data,(r)=>{
      loading.value = false
      emit("login", r)
    },()=>{loading.value = false})
  }, () => loading.value = false)
}

const getSms = () => {
  if (!/^1[2-9]\d{9}$/.test(data.value.account)) {
    return ElMessage.error("请输入正确的手机号码")
  }

  loading.value = true
  new axiosApi({
    encode: 'site',
    method: 'user/xm_code',
    body: {mobile: data.value.account}
  }).send(res => {
    loading.value = false
    if (res.message.code !== "000") {
      return ElMessage.error(res.message.content)
    }
    data.value.sms_text = res.data.trace_credential
    number.value = 60
    djs()
  }, () => loading.value = false)
}

const djs = () => {
  if (number.value < 1) {
    clearTimeout(timer)
  }
  timer = setTimeout(() => {
    number.value--
    djs()
  }, 1000);
}
</script>

<template>
  <el-drawer v-model="props.showLogin" direction="btt" :show-close="false" class="xiamen-login" size="290"
             @close="emit('closed')" @open="open">
    <template #header>
      <div class="xiamen-login-title">
        <div class="xiamen-login-title-text">白鹭会员登录</div>
        <div class="xiamen-login-title-tips">支持厦门航空、河北航空、江西航空</div>
      </div>
    </template>
    <el-form ref="xm_air" class="xm_air_login_form" :model="data">
      <el-form-item prop="account">
        <div class="xiamen-login-input">
          <el-input v-model="data.account" placeholder="请输入手机号码"/>
          <el-button type="warning" link :loading="loading" @click="getSms">{{ text }}</el-button>
        </div>
      </el-form-item>
      <el-form-item prop="account">
        <div class="xiamen-login-input">
          <el-input v-model="data.password" placeholder="请输入验证码" maxlength="6"/>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" round class="xiamen-login-btn" :loading="loading" @click="login">登录</el-button>
      </el-form-item>
    </el-form>
  </el-drawer>
</template>

<style lang="less">
.xiamen-login {
  border-radius: 16px 16px 0 0;

  .el-drawer__header {
    margin-bottom: 0;
  }

  .xiamen-login-title {
    text-align: center;
    line-height: 30px;
    border-bottom: 1px solid #008CD6;
    padding-bottom: 10px;

    .xiamen-login-title-text {
      font-size: 1.45rem;
      color: #008CD6;
    }

    .xiamen-login-title-tips {
      color: var(--el-color-info);
      font-size: .8rem;
    }
  }
}

.xm_air_login_form {
  width: 85%;
  margin: 0 auto;

  .xiamen-login-input {
    display: flex;
    align-items: center;
    justify-content: center;

    .el-input {
      //flex-basis: 60%;
      .el-input__wrapper {
        box-shadow: none;
        border-radius: 0;
        line-height: 45px;
        border-bottom: #008CD6 2px solid;
        margin-right: 10px;
      }
    }
  }
}

.xiamen-login-btn {
  width: 220px;
  margin: auto;
  background: #008CD6 !important;
  border-color: #008CD6 !important;
}
</style>
